// extracted by mini-css-extract-plugin
export var boxItems = "_72-1";
export var boxItemsLg = "_72-2";
export var button = "_72-7";
export var buttonLg = "_72-8";
export var filterGroupBox = "_72-0";
export var icon = "_72-3";
export var iconSecondary = "_72-6";
export var iconWrapper = "_72-4";
export var iconWrapperLg = "_72-5";